<template>
  <div>
    <h5>فروشگاه‌های برتر</h5>
    <CRow v-if="!selectedStores" class="scroll-bar">
      <CCol col="9" sm="2" v-for="i in 6" :key="i">
        <CCard>
          <CCardBody class="mx-auto pb-0">
            <div class="animated-background s-4 mx-auto" style="height:75px;width:75px;"></div>
            <span class="animated-background d-block text-center h6 mt-2 mb-3" style="height:20px;"></span>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow v-else class="scroll-bar">
      <CCol col="9" sm="2" v-for="(store, index) in selectedStores" :key="index">
        <CLink :to="{name: 'stores.profile', params: {id: store.id}}" class="text-decoration-none text-dark">
          <CCard>
            <CCardBody class="mx-auto pb-0">
              <CImg class="d-block mx-auto" :src="store.logo" width="75" height="75" />
              <span class="d-block text-center h6 mt-2 mb-3">{{ store.name }}</span>
            </CCardBody>
          </CCard>
        </CLink>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { StoreStatus } from "@/constants";
import { storeService } from "@/services/api";

export default {
  name: "SelectedStores",

  data() {
    return {
      selectedStores: undefined
    }
  },

  created() {
    storeService.fetch({
      no_paginate: true,
      limit: 6,
      status: StoreStatus.ACTIVE,
      min_selected: 1,
      sorter: {
        column: 'selected',
        direction: 'desc'
      },
      just: ['name', 'id', 'logo'],
    }).then(res => {
      this.selectedStores = res.data.data
    })
  }
}
</script>